import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, useSeo } from "@/lib/api";
import CouponCard from "@/components/CouponCard";
import StoreCard from "@/components/StoreCard";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function CategoryDetail() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [stores, setStores] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get(`/categories/${slug}`),
      api.get("/coupons", { params: { category: slug, limit: 100 } }),
      api.get("/stores", { params: { category: slug, limit: 50 } }),
    ]).then(([c, cp, st]) => {
      setCategory(c.data);
      setCoupons(cp.data);
      setStores(st.data);
    }).catch(console.error);
  }, [slug]);

  useSeo(
    category ? `${category.name} Coupons & Deals — SharePromos` : "Category",
    category ? `Best ${category.name.toLowerCase()} promo codes and deals — verified daily by SharePromos editors.` : "",
    {
      keywords: category ? `${category.name} coupons, ${category.name} promo codes, ${category.name} deals, ${category.name} discounts, ${category.slug} savings` : undefined,
    }
  );

  if (!category) return <div className="max-w-7xl mx-auto px-6 py-20">Loading…</div>;

  return (
    <div data-testid="category-detail-page">
      <div className="border-b border-slate-200 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <Breadcrumbs items={[
            { label: "Categories", to: "/categories" },
            { label: category.name },
          ]} />
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter uppercase mb-4">{category.name}</h1>
          <p className="text-slate-600 leading-relaxed max-w-2xl">{category.description}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        {stores.length > 0 && (
          <>
            <h2 className="font-display text-2xl md:text-3xl tracking-tight mb-6">Top {category.name} Stores</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-16">
              {stores.map((s) => <StoreCard key={s.slug} store={s} />)}
            </div>
          </>
        )}

        <h2 className="font-display text-2xl md:text-3xl tracking-tight mb-6">
          Active {category.name} Coupons ({coupons.length})
        </h2>
        <div className="grid grid-cols-1 gap-3">
          {coupons.map((c) => <CouponCard key={c.id} coupon={c} />)}
        </div>
      </div>
    </div>
  );
}
